import { render } from "./FriendsPage.vue?vue&type=template&id=708e186a&scoped=true"
import script from "./FriendsPage.vue?vue&type=script&lang=js"
export * from "./FriendsPage.vue?vue&type=script&lang=js"

import "./FriendsPage.vue?vue&type=style&index=0&id=708e186a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708e186a"]])

export default __exports__